let imgShow1 = "http://134.134.2.204:8888/";//非查询的图片显示
let imgShow2 = "http://134.134.2.26:8888/";//非查询的图片显示
/*本地环境*/
let localTest = {
  rootUrl: 'http://localhost:8091/api',
  rootUrl_37: 'http://134.134.2.36:6060',
  domain: 'http://localhost:8081',
  rootUrlDownload: 'http://testservice.kangxin.com'
}
/*开发环境*/
let dev = {
  rootUrl: 'http://134.134.2.36:9090/api',
  rootUrl_37: 'http://134.134.2.37',
  domain: 'http://134.134.2.37',
  rootImgUrl: imgShow1,
  rootImgUrl_qiufeng: "http://134.134.2.25:8080",//查询图片显示
}
/*微信外网测试环境*/
let demo = {
  rootUrl: 'http://mtestservice.kangxin.com:9031/api',
  // rootUrl: 'http://mtestservice.kangxin.com/api',
  rootUrl_37: 'http://134.134.2.37:9031',
  domain: 'http://mtestsso.kangxin.com:9031',
  ssodomain: 'http://mtestsso.kangxin.com:9073',
  rootImgUrl: 'https://testimage.kangxin.com/',//非查询的图片显示
  rootImgUrl_qiufeng: "https://tmimage.kangxin.com/",//查询图片显示
}
/*正式环境*/
let prodocut = {
  rootUrl: 'https://mservice.kangxin.com/api',
  rootUrl_37: 'http://134.134.2.37',
  domain: 'https://msso.kangxin.com',
  ssodomain: 'https://msso.kangxin.com',
  rootImgUrl: 'https://tmimage2.kangxin.com/',//非查询的图片显示
  rootImgUrl_qiufeng: "https://tmimage.kangxin.com/",//查询图片显示
}
let environment = {}
if (window.location.hostname == 'mservice.kangxin.com') {
  environment = prodocut
} else if (window.location.hostname == 'mtestservice.kangxin.com') {
  environment = demo
}else if (window.location.hostname == 'localhost') {
  environment = prodocut// 开发的时候随时调整的是这个
} else {
  environment = dev
}
export let {rootUrl, rootUrl_37, domain,ssodomain, rootImgUrl, rootImgUrl_qiufeng}=environment;




// WEBPACK FOOTER //
// ./src/service/rootUrl.js